const initialState = {
  UomList: [],
  isAddingUom: false,
};

const uomReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_ADD_UOM":
      return { ...state, isAddingUom: true };
    case "SUCCESS_ADD_UOM":
      return { ...state, UomList: action.payload, isAddingUom: false };
    case "ERROR_ADD_UOM":
      return { ...state, isAddingUom: false };

      
    case "REQUEST_UOM":
      return { ...state, isFetchingUOM: true };
    case "SUCCESS_UOM":
      return { ...state, UOMList: action.payload.data, isFetchingUOM: false };
    case "ERROR_UOM":
      return { ...state };

    default:
      return state;
  }
};
export default uomReducer;